var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Menu'),_vm._v(" "),(_vm.$store.state.loading)?_c('loading-spinner'):_vm._e(),_vm._v(" "),_c('section',{staticClass:"app-section"},[_c('NavBarCompany'),_vm._v(" "),_c('nuxt')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }